"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));
/*
 * Display an material-ui Avatar
 * If boolean internal is true, it displays white avatar with colored border and colored text
 * If internal is false, it displays classic Avatar with colored background
 */
var HiAvatar = (0, _styledComponents.default)(function (_ref) {
  var internal = _ref.internal,
    color = _ref.color,
    other = (0, _objectWithoutProperties2.default)(_ref, ["internal", "color"]);
  return /*#__PURE__*/_react.default.createElement(_Avatar.default, other);
}).withConfig({
  displayName: "HiAvatar",
  componentId: "sc-4o6l6c-0"
})(["background-color:", ";color:", ";border:", ";"], function (props) {
  return props.internal ? 'white' : props.color;
}, function (props) {
  return props.internal && props.color;
}, function (props) {
  return props.internal && "solid 1px ".concat(props.color);
});
HiAvatar.propTypes = {
  /* If internal user, display Avatar colors reversed */
  internal: _propTypes.default.bool,
  /* Avatar color */
  color: _propTypes.default.string
};
HiAvatar.defaultProps = {
  internal: false
};
var _default = exports.default = HiAvatar;